module.exports = __webpack_public_path__ + "static/media/pn.9a64363c.webp";